<template>
  <form name="files" @submit.prevent="$emit('save')">
    <BLayoutExpansion title="Основное" class="my-4">
      <v-row dense>
        <v-col cols="12" lg="4">
          <BTextField
            v-model="form.name"
            validate="required"
            label="Название"
            :disabled="isView"
            :skeleton="skeleton"
            name="name"
            autofocus
          />
        </v-col>

        <v-col cols="12" lg="4">
          <BTextField
            :value="form.owner && form.owner.full_name"
            label="Владелец"
            disabled
            :skeleton="skeleton"
            name="full_name"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" lg="8">
          <BAutocompleteCommon
            v-model="form.tags"
            $type="file-tag"
            :disabled="isView"
            :skeleton="skeleton"
            multiple
            name="tags"
          />
        </v-col>
      </v-row>

      <v-row v-if="!isCreate" dense>
        <v-col :cols="!skeleton && 'auto'">
          <BTextField
            :value="data.created_at | dateFormatter"
            :skeleton="skeleton"
            label="Создан"
            disabled
          />
        </v-col>

        <v-col :cols="!skeleton && 'auto'">
          <BTextField
            :value="data.updated_at | dateFormatter"
            :skeleton="skeleton"
            label="Обновлен"
            disabled
          />
        </v-col>
      </v-row>
    </BLayoutExpansion>

    <BLayoutExpansion title="Файл" class="mb-4">
      <v-row dense align="center">
        <!--
        <v-col cols="auto">
          <v-avatar v-if="form.raw_file">
            <v-img :src="form.raw_file.url" />
          </v-avatar>
        </v-col>
        -->

        <v-col cols="12" lg="8">
          <FilesFormFileInput
            v-model="form.raw_file"
            :visible-file-name="form.name"
            validate="required"
            :disabled="isView"
            :skeleton="skeleton"
          />
        </v-col>
      </v-row>
    </BLayoutExpansion>

    <button type="submit" class="d-none" />
  </form>
</template>

<script>
import BLayoutForm from '@/components/layouts/BLayoutForm.vue'
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'
import BTextField from '@/components/forms/BTextField.vue'
import BAutocompleteCommon from '@/components/forms/BAutocompleteCommon.vue'
import FilesFormFileInput from './FilesFormFileInput.vue'


const createDefaultData = () => ({
  // id
  name: '',
  raw_file: null,
  // owner
  tags: [],
  // created_at
  // updated_at
})

export default {
  name: 'FilesForm',
  components: {
    BLayoutExpansion,
    BTextField,
    BAutocompleteCommon,
    FilesFormFileInput,
  },
  extends: BLayoutForm,
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      required: true,
      default: createDefaultData,
    },
  },
  data: () => ({
    isLoadingFile: false,
    file: null,
  }),
  methods: {
    async onSubmit() {
      const result = await this.$validator.validate()

      if (!result) {
        this.$notice.validatorFormError(this)
        const message = `Error submit: ${this.$options.name}`
        const error = new Error(message)
        return Promise.reject(error)
      }

      const { form } = this

      const data = {
        ...form,

        raw_file_id: form.raw_file?.id,
        raw_file: void 0,
      }

      this.$emit('submit', data)

      return data
    },
  },
}
</script>
